import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
const _exp = /*#__PURE__*/() => ({
  marginTop
}) => marginTop ?? 0;
const FlexRow = /*#__PURE__*/styled('div')({
  name: "FlexRow",
  class: "fkpf4q4",
  propsAsIs: false,
  vars: {
    "fkpf4q4-0": [_exp(), "px"]
  }
});
export const ReviewsSectionLoadingState = () => {
  return <div>
      <div>
        <SkeletonLoader width={100} height={25} marginTop={0} />
        <SkeletonLoader width={120} height={40} marginTop={20} />
        <FlexRow marginTop={15}>
          <SkeletonLoader width={110} marginTop={0} height={25} />
          <SkeletonLoader width={120} marginTop={0} height={25} />
        </FlexRow>
        <FlexRow marginTop={10}>
          <SkeletonLoader width={130} marginTop={0} height={25} />
          <SkeletonLoader width={90} marginTop={0} height={25} />
        </FlexRow>
        <SkeletonLoader width={100} height={18} marginTop={25} />
        <FlexRow marginTop={10}>
          <SkeletonLoader circle width={40} marginTop={0} height={40} />
          <SkeletonLoader circle width={40} marginTop={0} height={40} />
          <SkeletonLoader circle width={40} marginTop={0} height={40} />
          <SkeletonLoader circle width={40} marginTop={0} height={40} />
        </FlexRow>
      </div>
    </div>;
};

require("./ReviewSectionLoadingState.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ReviewSectionLoadingState.tsx");